var _templateObject, _templateObject2;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import { Box } from '@creditas-ui/layout';
import { styled, css } from '@creditas-ui/system';
import { ifProp } from '@creditas-ui/utilities';
import { GlobalIcons } from './GlobalIcons.styles';
var disabled = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  cursor: not-allowed;\n"])));
export var ButtonIcon = styled(Box.withComponent(GlobalIcons, process.env.NODE_ENV === "production" ? {
  target: "e1nvu0ts0"
} : {
  target: "e1nvu0ts0",
  label: "ButtonIcon"
}))(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  cursor: pointer;\n\n  padding: 0;\n  border: 0;\n  background-color: transparent;\n\n  ", "\n"])), ifProp('disabled', disabled));
//# sourceMappingURL=ButtonGlobalIcons.styles.js.map